import { useContext } from 'react';
import { useSelector } from 'react-redux';
import UnlockTimerContext from '~/context/vdp/UnlockTimerContext';
import {
  getAlertStatus,
  getIsReservableVehicle,
  getIsVehicleReservedByOther,
  getIsVehicleReservedByUser
} from '~/selectors';

export default function useHasVehicleNotifyStatus() {
  const { shouldShowTimer } = useContext(UnlockTimerContext);
  const { purchasePending } = useSelector(getAlertStatus);
  const isReservable = useSelector(getIsReservableVehicle);
  const isReservedByOther = useSelector(getIsVehicleReservedByOther);
  const isReservedByUser = useSelector(getIsVehicleReservedByUser);

  return (
    !isReservedByOther &&
    !isReservedByUser &&
    (purchasePending || shouldShowTimer || isReservable)
  );
}
